import { AbyssCommonContent } from "../../../../modules/content/components/AbyssCommonContent/AbyssCommonContent";
import { AbyssRichText } from "../../../../modules/content/components/AbyssRichText/AbyssRichText";
import { AbyssSection } from "../../../../modules/content/components/AbyssSection/AbyssSection";
import type { IWysiwygBlockProps } from "./WysiwygBlock.props";

export const WysiwygBlock = ({
  alignment,
  anchorId,
  buttons,
  content,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
}: IWysiwygBlockProps) => {
  if (!content) return null;
  const hasIntro = Boolean(eyebrow || heading || description || buttons?.length);

  return (
    <AbyssSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-10 md:gap-14">
        {hasIntro ? (
          <AbyssCommonContent
            alignment={alignment}
            buttons={buttons}
            description={description}
            eyebrow={eyebrow}
            heading={heading}
          />
        ) : null}
        <AbyssRichText className="abyss-prose" content={content} />
      </div>
    </AbyssSection>
  );
};

WysiwygBlock.displayName = "Block::WysiwygBlock";
